import React,{ useState }  from 'react';
import { darkenColor } from "../constants/darkenColor";
import { lightenColor } from "../constants/lightenColor";
interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  configData: any;
  title: string;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({ isOpen, onClose, onConfirm,configData, title }) => {
  const [loading, setLoading] = useState(false); 
  if (!isOpen) return null;
const darkerBackground = darkenColor(configData.app_ui_settings.ui_backgroundcolor, 8);
const lighterInputBoxBackground = lightenColor(configData.app_ui_settings.ui_backgroundcolor, 7);
const fontColor =  configData.app_ui_settings.ui_fontcolor;

const handleDelete = async () => {
  setLoading(true); // Show loader
  try {
    await onConfirm(); // Perform the delete operation
  } catch (error) {
    console.error("Error during delete:", error);
  } finally {
    setLoading(false); // Hide loader after operation
  }
};
  return (
    <div className="modal-overlay" >
      <div className="modal-content" style={{ backgroundColor: lighterInputBoxBackground, color:fontColor }}>
        {/* Header */}
        <div className="modal-header" style={{ backgroundColor: lighterInputBoxBackground , color: fontColor}}>
          <h2>Delete Chat</h2>
          
        </div>

        {/* Content */}
        <div className="modal-body" style={{ backgroundColor: lighterInputBoxBackground , color: fontColor}}>
          <p>This will delete <span className="font-bold">{title}</span>.</p>
        </div>

        {/* Footer with buttons */}
        <div className="modal-footer">
          <button onClick={onClose} style={{ borderColor: configData.app_ui_settings.ui_fontcolor, color: configData.app_ui_settings.ui_fontcolor }} 
  className="rounded-full shadow-lg border hover:brightness-75">Cancel</button>
   <button 
  onClick={handleDelete} 
  className="confirm-btn rounded-full shadow-lg border hover:brightness-75"
  disabled={loading} // Disable button while loading
  style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} // Flexbox to align text and loader
>
  {loading ? (
    <>
      <span>Deleting</span>
      <div className="delete-loader" style={{ marginLeft: '8px' }}></div> {/* Add space between text and loader */}
    </>
  ) : (
    "Delete"
  )}
</button>

          {/* <button onClick={onConfirm} className="confirm-btn rounded-full shadow-lg border hover:brightness-75">Delete</button> */}
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
